import {useEffect} from 'react';
import voiture from "@/assets/images/accidents/voiture_topview.png";
import moto from "@/assets/images/accidents/moto_topview.png";
import quad from "@/assets/images/accidents/quad_topview.png";
import RadioChoc from "@/components/forms/radio-choc";
import { useSelectedContract } from '@/hooks/api/use-contracts';
import type { DeclarationStepProps } from '@/pages/accident/declaration-sinistre/types';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Crosshair } from 'lucide-react';

const Chocs = (props: DeclarationStepProps) => {
    const { values, setValue } = props
    const produit = useSelectedContract()?.vehicule?.codeProduit

    useEffect(() => {
        let choc: string

        switch(values.point_choc) {
            case 'bottom':
                choc = 'Arrière - '
                break
            case 'top':
                choc = 'Avant - '
                break
            case 'left':
                choc = 'Coté gauche - '
                break
            case 'right':
                choc = 'Coté droit - '
                break
            case 'top_right':
                choc = 'Avant droit - '
                break
            case 'top_left':
                choc = 'Avant gauche - '
                break
            case 'bottom_left':
                choc = 'Arrière gauche - '
                break
            case 'bottom_right':
                choc = 'Arrière droit - '
                break
            case 'middle_right':
                choc = 'Coté droit - '
                break
            case 'middle_left':
                choc = 'Coté gauche - '
                break
            default:
                choc = 'Non défini - '
        }

        setValue('dommagesDeclares', `Point de choc : ${choc}`)

    }, [values.point_choc])

    return (
        <Card className="mt-6">
            <CardHeader className="pb-6 border-b">
                <CardTitle className="text-lg flex items-center gap-2">
                    <Crosshair className="w-5 h-5 text-primary" />
                    Sélectionner la case correspondant au point de choc initial de l'accident sur votre véhicule
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-6">
                {(produit === 'AUTOF3' || produit === '7311_AUT1') && (
                    <div className="my-12">
                        <RadioChoc
                            name={'point_choc'}
                            type={'voiture'}
                            image={voiture}
                            setValue={setValue}
                            options={[
                                { value: 'top_right', label: 'top_right' },
                                { value: 'top_left', label: 'top_left' },
                                { value: 'bottom_left', label: 'bottom_left' },
                                { value: 'bottom_right', label: 'bottom_right' },
                                { value: 'left', label: 'left' },
                                { value: 'right', label: 'right' },
                            ]}
                            value={values.point_choc}
                        />
                    </div>
                )}

                {produit === '7311_PVK' && (
                    <div className="my-12">
                        <RadioChoc
                            name={'point_choc'}
                            type={'quad'}
                            image={quad}
                            setValue={setValue}
                            options={[
                                { value: 'top_right', label: 'top_right' },
                                { value: 'top_left', label: 'top_left' },
                                { value: 'bottom_left', label: 'bottom_left' },
                                { value: 'bottom_right', label: 'bottom_right' },
                                { value: 'left', label: 'left' },
                                { value: 'right', label: 'right' },
                            ]}
                            value={values.point_choc}
                        />
                    </div>
                )}

                {produit !== '7311_PVK' && produit !== 'AUTOF3' && produit !== '7311_AUT1' && (
                    <div className="my-12">
                        <RadioChoc
                            name={'point_choc'}
                            type={'moto'}
                            image={moto}
                            setValue={setValue}
                            options={[
                                { value: 'top', label: 'top' },
                                { value: 'top_left', label: 'top_left' },
                                { value: 'middle_left', label: 'middle_left' },
                                { value: 'bottom_left', label: 'bottom_left' },
                                { value: 'bottom', label: 'bottom' },
                                { value: 'top_right', label: 'top_right' },
                                { value: 'middle_right', label: 'middle_right' },
                                { value: 'bottom_right', label: 'bottom_right' },
                            ]}
                            value={values.point_choc}
                        />
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default Chocs;
